<script>
  // Add your JavaScript code here
</script>

<style>
    footer {
        background-color: #333;
        color: white;
        padding: 1rem;
        text-align: center;
        font-size: 0.9rem;
    }
</style>

<footer>
    &copy; 2023 Your Name. All rights reserved.
</footer>
